var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Badge } from "../generic/badge/Badge";
import { Button } from "../generic/button/Button";
import { ModalButtonClose } from "../generic/common/ModalButtonClose";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { menuTabs } from "../menus/menuTabs";
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        var tabIndex = props.activeTabIndex || 0;
        _this.state = {
            activeTabIndex: tabIndex,
        };
        if (_this.props.onSelect) {
            _this.props.onSelect(tabIndex);
        }
        return _this;
    }
    Tabs.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.activeTabIndex != undefined) {
            this.setState({
                activeTabIndex: nextProps.activeTabIndex,
            });
        }
    };
    Tabs.prototype.render = function () {
        var onClose = this.props.onClose;
        var tabItems = this.getTabItems();
        var activeTabContent = this.getActiveTabContent();
        return (React.createElement("div", { className: "tabs-wrapper" },
            React.createElement("div", { className: "tabs-row wooden-texture-background " + IdStyles.ModalHeader },
                React.createElement("div", { className: "tabs-row__items" }, tabItems),
                React.createElement(ModalButtonClose, { onClick: onClose, className: "modal-header__close" })),
            React.createElement("div", { className: "tabs-content" }, activeTabContent)));
    };
    Tabs.prototype.handleTabClick = function (tabIndex) {
        var onSelect = this.props.onSelect;
        var activeTabIndex = this.state.activeTabIndex;
        if (tabIndex === activeTabIndex) {
            return;
        }
        this.setState({
            activeTabIndex: tabIndex,
        });
        if (onSelect) {
            onSelect(tabIndex);
        }
    };
    Tabs.prototype.getTabItems = function () {
        var _this = this;
        var activeTabIndex = this.state.activeTabIndex;
        var tabs = this.props.tabs;
        return tabs.map(function (tab, index) {
            var disabled = tab.disabled, locked = tab.locked, badge = tab.badge, id = tab.id, icon = tab.icon;
            var isTabActive = activeTabIndex === index;
            var tabName = isTabActive ? (React.createElement("div", { className: "tabs-row__item-text" },
                React.createElement(TextLoca, { className: IdStyles.HeadlineOne, id: tab.locaKey }))) : (undefined);
            if (locked) {
                return (React.createElement(Button, { className: "tabs-row__item " + IdStyles.TabItemBackground, key: id, disabled: disabled },
                    React.createElement(Icon, { icon: IdIcon.LockIcn, styleId: IdStyles.IconMedium })));
            }
            var badgeElement = badge != undefined && React.createElement(Badge, __assign({}, badge));
            return (React.createElement(Button, { onClick: function () { return _this.handleTabClick(index); }, className: "tabs-row__item " + IdStyles.TabItemBackground + " " + (isTabActive ? "selected" : ""), key: id, disabled: disabled },
                React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
                tabName,
                badgeElement));
        });
    };
    // Render current active tab content
    Tabs.prototype.getActiveTabContent = function () {
        var activeTabIndex = this.state.activeTabIndex;
        var _a = this.props, tabs = _a.tabs, type = _a.type;
        try {
            var activeTab = tabs[activeTabIndex];
            var categoryConfig = menuTabs[type].categories[activeTab.id];
            var Component = categoryConfig.domComponent;
            return React.createElement(Component, null);
        }
        catch (err) {
            // tslint:disable-next-line:no-null-keyword
            return null;
        }
    };
    return Tabs;
}(React.Component));
export { Tabs };



//////////////////
// WEBPACK FOOTER
// ./src/features/tabs/Tabs.tsx
// module id = 2574
// module chunks = 3